// Mock data for Nanhe Kadam Therapy Centre clone

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_images-85/artifacts/nxt2eilc_image.png";

export const PHONE = "+91 88046 91673";
export const PHONE_RAW = "+918804691673";
export const EMAIL = "nanhekadam2025.in@gmail.com";
export const WHATSAPP_BASE = "https://wa.me/918804691673";

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Directors", href: "#directors" },
  { label: "Gallery", href: "#gallery" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const heroStats = [
  { value: "500+", label: "Children helped" },
  { value: "8+", label: "Therapy services" },
  { value: "5★", label: "Parent rating" },
];

export const corePrograms = [
  {
    title: "Occupational Therapy",
    sub: "Fine motor • Sensory • Daily-living skills",
    img: "https://images.pexels.com/photos/7459321/pexels-photo-7459321.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Speech Therapy",
    sub: "Articulation • Language • Communication",
    img: "https://images.pexels.com/photos/33815027/pexels-photo-33815027.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Behaviour Therapy",
    sub: "Emotion regulation • Focus • Positive habits",
    img: "https://images.pexels.com/photos/33644645/pexels-photo-33644645.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Special Education",
    sub: "Individualised learning • Academic support",
    img: "https://images.pexels.com/photos/35552523/pexels-photo-35552523.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const services = [
  {
    title: "Speech Therapy",
    desc: "Help your child find their voice — articulation, language delays, stuttering & social communication.",
    icon: "MessageCircle",
    color: "bg-orange-50 text-orange-500",
  },
  {
    title: "Occupational Therapy",
    desc: "Build fine motor, sensory processing and daily-living skills for greater independence.",
    icon: "Hand",
    color: "bg-green-50 text-green-600",
  },
  {
    title: "Behaviour Therapy",
    desc: "Positive, structured strategies that help children regulate emotions and improve behaviour.",
    icon: "Smile",
    color: "bg-orange-50 text-orange-500",
  },
  {
    title: "Special Education",
    desc: "Individualised learning plans for children with developmental, learning and academic needs.",
    icon: "BookOpen",
    color: "bg-green-50 text-green-600",
  },
  {
    title: "Physiotherapy",
    desc: "Pediatric physio for posture, gross motor delays, low tone and neuro-developmental needs.",
    icon: "Activity",
    color: "bg-green-50 text-green-600",
  },
  {
    title: "ABA Therapy",
    desc: "Applied Behaviour Analysis — evidence-based skill building for children on the spectrum.",
    icon: "Puzzle",
    color: "bg-orange-50 text-orange-500",
  },
  {
    title: "Autism Care",
    desc: "Comprehensive early-intervention programs designed for children with ASD.",
    icon: "Sparkles",
    color: "bg-orange-50 text-orange-500",
  },
  {
    title: "ADHD Support",
    desc: "Focus, attention & self-regulation coaching for children with ADHD and similar profiles.",
    icon: "Zap",
    color: "bg-green-50 text-green-600",
  },
];

export const marqueeItems = [
  "Speech Therapy",
  "Occupational Therapy",
  "Behaviour Therapy",
  "ABA Therapy",
  "Special Education",
  "Autism Care",
  "ADHD Support",
  "Physiotherapy",
];

export const directors = [
  {
    name: "Chandan Kumar",
    role: "Founder & Director",
    bio: "A passionate child-development advocate from Patna, dedicated to building inclusive, high-quality therapy access for families across Bihar.",
    img: "https://customer-assets.emergentagent.com/job_images-85/artifacts/lm2k8tw3_2ee4487e-d312-41ce-aaa1-5904b9ae06f1.png",
    phone: "+91 88046 91673",
    phoneRaw: "+918804691673",
    email: "nanhekadam2025.in@gmail.com",
  },
  {
    name: "Clinical Director",
    role: "Co-Director, Clinical Lead",
    bio: "Leads our multidisciplinary clinical team — overseeing therapy design, assessment protocols and parent training programs.",
    img: "https://customer-assets.emergentagent.com/job_images-85/artifacts/p94m1ujj_4fa9d9ec-6229-42a5-8875-f9b53f314bb3.png",
    phone: "+91 98521 48616",
    phoneRaw: "+919852148616",
    email: "nanhekadam2025.in@gmail.com",
  },
];

export const galleryImages = [
  "https://customer-assets.emergentagent.com/job_images-85/artifacts/86lyuqfs_image.png",
  "https://customer-assets.emergentagent.com/job_images-85/artifacts/r37oyxbv_image.png",
  "https://customer-assets.emergentagent.com/job_images-85/artifacts/dkq873vq_image.png",
  "https://customer-assets.emergentagent.com/job_images-85/artifacts/ceot04lk_image.png",
  "https://customer-assets.emergentagent.com/job_images-85/artifacts/dlqhnag1_image.png",
  "https://customer-assets.emergentagent.com/job_images-85/artifacts/ax2fcue0_image.png",
];

export const testimonials = [
  {
    name: "Priya Sharma",
    when: "2 weeks ago",
    avatar: "https://i.pravatar.cc/100?img=47",
    text: "My son's speech has improved dramatically in just 3 months. The therapists are patient, kind and so professional. Highly recommend Nanhe Kadam!",
  },
  {
    name: "Rahul Verma",
    when: "1 month ago",
    avatar: "https://i.pravatar.cc/100?img=12",
    text: "Excellent OT sessions for our daughter. Sensory room is amazing and the team explains every step to us as parents. Truly a child-first centre.",
  },
  {
    name: "Anjali Singh",
    when: "3 weeks ago",
    avatar: "https://i.pravatar.cc/100?img=32",
    text: "We tried 2 other centres before — none felt right. Nanhe Kadam genuinely cares. My child actually looks forward to therapy now.",
  },
];

export const instagramPosts = [
  {
    img: "https://images.pexels.com/photos/35745575/pexels-photo-35745575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    likes: 218,
    caption: "Sensory play that builds confidence, one step at a time. #NanheKadam",
  },
  {
    img: "https://images.pexels.com/photos/22616347/pexels-photo-22616347.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    likes: 342,
    caption: "Speech therapy through play — because every child deserves to be heard.",
  },
];

export const heroImage = "https://images.pexels.com/photos/8460046/pexels-photo-8460046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1000";
export const aboutImage = "https://images.pexels.com/photos/35745581/pexels-photo-35745581.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1000";
